import BackButton from "components/common/custom/back-button";
import FalconComponentCard from "components/common/FalconComponentCard";
import { Button, Col, Row, Form } from "react-bootstrap";
import paths from "routes/paths";
import ClaimUpload from "./ClaimUpload";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
  handleResetExcel,
  setIsExcelValid,
  setValidationErrors,
  setValidationExcelErrors,
} from "../config/claimSlice.js";
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import { CreateMultipleClaimFromExcel } from "../config/cliamApi";
import { useNavigate } from "react-router-dom";
import { cleanObjectExcept } from "features/preauthorization/utils";
const ClaimImport = () => {
  const dispatch = useDispatch();
  const { isExcelValid, mainData, excelData } = useSelector(
    (state) => state.claim
  );

  console.log({ excelData });

  const [file, setFile] = useState(null);
  const {
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm();
  useEffect(() => {
    dispatch(handlePreauthFormData({ check: "reset" }));
    dispatch(handleResetCreateClaim());
    dispatch(handleResetAll({ check: "reset" }));
    dispatch(handleResetPatientSearch());
  }, []);

  const navigate = useNavigate();

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  console.log({ excelData });

  // Main onSubmit function
  const onSubmit = async (data) => {
    console.log("lll");
    var allData = excelData;

    if (!allData || !allData?.Main || allData.Main.length === 0) {
      toast.error("No data to submit");
      return;
    }

    const body = {
      branch_id: selectedBranch?.value || selectedBranch?.branch_id || 1,
      insurance_company_id: watch("payer")?.insurance_company_id || "",
      btch_month: watch("claim_date")
        ? moment(watch("claim_date")).format("YYYY-MM")
        : moment().format("YYYY-MM"),
      claim_data: {},
    };

    // Helper: Safe string
    const str = (val) => (val != null ? String(val).trim() : "");
    // Helper: Safe number
    const num = (val) => (val != null ? parseFloat(val) || 0 : 0);

    console.log({ allData });

    // Helper: Safe date
    const formatDate = (date) =>
      date ? moment(date).format("YYYY-MM-DD") : "";

    allData.Main.forEach((mainRow) => {
      const seq = str(mainRow.Claim_Seq_No);
      if (!seq) return;

      console.log({ encounterClass: mainRow.EncounterClass })

      const claimTypeCode = num(mainRow.Claim_Type);
      const claimSubTypeCode = num(mainRow.Claim_Sub_Type);
      const isInstitual = claimTypeCode == 1;
      const isPharmacy = claimTypeCode === 3;
      const isProfEmer = claimTypeCode === 4 && claimSubTypeCode == 3;
      console.log({ claimTypeCode, claimSubTypeCode });
      const isProfOut = claimTypeCode === 4 && claimSubTypeCode == 2;
      const isDental = claimTypeCode === 2;
      const isVision = claimTypeCode === 5;
      const isPrescription = str(mainRow.IsPrescription).toLowerCase() === "y";

      const isAdmissionDate = isInstitual || isDental || isProfOut || isProfEmer;
      const isEncounterClass = isDental || isProfEmer || isProfOut || isInstitual;
      const isEncounterStatus = isDental || isProfEmer || isProfOut || isInstitual;
      const isServiceEventType = isDental || isProfOut || isProfEmer;
      const isDischargeDate = isInstitual || isDental || isProfOut || isProfEmer;
      const isCareType = isDental || isProfOut || isProfEmer || isInstitual;
      const isActPriorty = isDental || isProfOut || isProfEmer || isInstitual;
      const isCauseOfDeath = isDental || isProfOut || isProfEmer || isInstitual;
      const isLastMenstualCycle = isDental || isProfOut || isProfEmer || isInstitual;
      const isTriage = isProfEmer;
      const isEmerServStartDate = isProfEmer;
      const isEmerDepartDis = isProfEmer;
      const isEmerArrivalCode = isProfEmer;
      const isDischargeDisposition = isInstitual;
      const isDischargeSpeciality = isInstitual;
      const isEncounterAdmitSource = isInstitual;
      const isIntendLength = isInstitual;
      const isEstimenatedLength = isInstitual;

      const claimKey = seq;



      // Related data
      const practitioners = (allData.Practitioner || []).filter(
        (p) => str(p.Claim_Seq_No) === seq
      );
      const services = (allData.Services || []).filter(
        (s) => str(s.Claim_Seq_No) === seq
      );
      const diagnoses = (allData.Diagnosis || []).filter(
        (d) => str(d.Claim_Seq_No) === seq
      );
      const optical = (allData.Optical || []).find(
        (o) => str(o.Claim_Seq_No) === seq
      );

      // === Practitioner ===
      const pract_id = {};
      practitioners.forEach((pract, idx) => {
        pract_id[idx + 1] = {
          tabebek_pract_id: "",
          pract_uuid: "",
          pract_id: "",
          pract_license: str(pract.LicenseNumber) || "",
          pract_name: str(pract.DOCTOR_NAME) || "",
          pract_finame: "",
          pract_faname: "",
          pract_spec: "",
          pract_spec_code: str(pract.SPECIALTY) || "",
          role: str(pract.ROLE) || "",
        };
      });

      const sup_info_suply = {};

      services.forEach((item, index) => {
        const key = String(index + 1);
        if (
          item.DaysSupply !== null &&
          item.DaysSupply !== undefined &&
          item.DaysSupply !== ""
        ) {
          sup_info_suply[key] = item?.["DaysSupply"];
        }
      });

      // === Diagnosis ===
      const diag = {};
      diagnoses.forEach((d, idx) => {
        diag[idx + 1] = {
          diag_code: str(d.ICD10_Code) || "",
          diag_typ: str(d.DiagnosisType) || "",
          diag_onset: str(d.ConditionOnset) || "",
          on_adms: str(d.OnAdmission) || "",
        };
      });

      // === Services (prd_ser) ===

      // === sup_info (vitals & extras) ===
      const sup_info = {
        1: { systlc: str(mainRow["Systolic_B.P"]) || "" },
        2: { diastlc: str(mainRow["Diastolic_B.P"]) || "" },
        3: { wgt: str(mainRow.Weight) || "" },
        4: { hgt: str(mainRow.Height) || "" },
        5: { temp: str(mainRow.Temperature) || "" },
        6: { menstprd: isLastMenstualCycle ? formatDate(mainRow.last_menstral_code) : '' || "" },
        7: { icuhrs: str(mainRow.ICUHours) || "" },
        8: { plse: str(mainRow.Pulse) || "" },
        9: { vnthrs: str(mainRow.VentilationHours) || "" },
        10: { oxystrn: str(mainRow.OxygenSaturation) || "" },
        11: { brthwgt: str(mainRow.Birth_Weight) || "" },
        12: { resprte: str(mainRow.Respiratory_rate) || "" },
        13: { lgthsty: isEstimenatedLength ? str(mainRow.EstimatedLengthOfStay) : '' || "" },
        14: { empimp: { stdate: "", eddate: "" } },
        15: { addinfo: "" },
        16: { aspcnd: { code: "", dte: "" } },
        17: { chfcmp: { code: str(mainRow.Chief_Complaint) || "" } },
        18: { vreas: str(mainRow.Visit_Type) || "" },
        19: {
          invres: {
            code: "NA",
            oth: "",
            contentType: "",
            title: "",
            creation: "",
            data: "",
          },
        },
        20: { trtpln: str(mainRow.TreatmentPlan) || "" },
        21: { pathistry: str(mainRow.PatientHistory) || "" },
        22: { phyexmn: str(mainRow.PhysicalExamination) || "" },
        23: { histrypreill: str(mainRow.HistoryOfPresentIllness) || "" },
        24: { admnwgt: str(mainRow.AdmissionWeight) || "" },
        25: { morplgy: { code: "" } },
        26: {
          msngtooth: {
            code: str(mainRow.MissingToothNumber) || "",
            dte: formatDate(mainRow.MissingToothDate) || "",
            resncde: str(mainRow.MissingToothReason) || "",
          },
        },
        27: { Snomed: "" },
      };
      const extractedSupInfoFields = [];
      Object.entries(sup_info || {}).forEach(([_, fieldGroup]) => {
        if (!fieldGroup || typeof fieldGroup !== "object") return;

        Object.entries(fieldGroup).forEach(([fieldKey, fieldValue]) => {
          let hasValue = false;

          if (
            typeof fieldValue === "object" &&
            fieldValue !== null &&
            !Array.isArray(fieldValue)
          ) {
            hasValue = Object.values(fieldValue).some(
              (v) =>
                v !== null &&
                v !== undefined &&
                (typeof v !== "string" || v.trim() !== "")
            );
          } else {
            hasValue =
              fieldValue !== null &&
              fieldValue !== undefined &&
              (typeof fieldValue !== "string" || fieldValue.trim() !== "");
          }

          if (hasValue) {
            extractedSupInfoFields.push(fieldKey);
          }
        });
      });
      const prd_ser = {};
      services.forEach((srv, idx) => {
        const invoice = str(srv.Invoice_No) || "";

        prd_ser[idx + 1] = {
          invoice_no: invoice,
          preauth_ref: str(srv.PREAUTH) || "",
          prd_type: str(srv.ServiceType)?.toLowerCase() || "",
          prd_code: str(srv.Service_Code) || "",
          prd_descp_txt: str(srv.Service_Description) || "",
          prov_cde: str(srv?.Provider_Code || "") || "",
          prd_url_txt: "",
          prd_pri: num(srv.Unit_Price) || 0,
          prd_qty: num(srv.Qty) || 0,
          prd_namnt: num(srv.Net_Payable_Amount) + num(srv.NetVatAmount) || 0,
          discnt: num(srv.DiscountPercentage) || 0,
          prd_pshre: num(srv.Deductible) || 0,
          diag_tax: num(srv.VatIndicator) || 15,
          period: {
            start: formatDate(srv.Service_date) || "",
            end: formatDate(srv.Service_date) || "",
          },
          prd_packg: false,
          prd_mtrnty: str(srv?.IsMaternity)?.toLowerCase() == "y" || false,
          pract: practitioners
            .filter(
              (p) =>
                str(p.Claim_Seq_No).toLowerCase() ==
                str(srv?.Claim_Seq_No)?.toLowerCase()
            )
            .map((p) => p.LicenseNumber || "")
            .filter(Boolean),
          supinfo: extractedSupInfoFields,
          Sntfc_code: str(srv?.MedicationScientificCode) || "",
          strngth: str(srv?.Stength) || "",
          slct_rsn: str(srv?.MedicationSelectionReason) || "",
          duration: {
            start: srv?.MedicationStartDate
              ? formatDate(srv?.MedicationStartDate)
              : "",
            end: srv?.MedicationEndDate
              ? formatDate(srv?.MedicationEndDate)
              : "",
            dur_time: str(srv?.MedicationDuration) || "",
            dur_time_value: str(srv?.MedicationDurationUnit) || "",
          },
          frequency: {
            frq: str(srv?.MedicationFrequency) || "",
            frq_prd: str(srv?.MedicationPeriod) || "",
            frq_time_value: str(srv?.MedicationPeriodunit) || "",
          },
          dose: {
            dsg_prd: "",
            dsg_time_value: str(srv?.MedicationDose) || "",
            dsg_inst: str(srv?.MedicationDoseunit) || "",
          },
          ROA: str(srv?.MedicationRoute) || "",
          ROA_disp: str(srv?.MedicationRouteDisplay) || "",
          time_inst: str(srv?.MedicationTimeInstruction) || "",
          time_inst_disp: str(srv?.MedicationTimeInstructionDisplay) || "",
          refill_count: str(srv?.MedicationRefillCount) || "",
          pat_inst: str(srv?.MedicationDosageInstruction) || "",
          dosage_instruction: str(srv?.MedicationPatientInstruction) || "",
          orl_reg_code: "",
          body_site: str(srv?.BodySite) || "",
          orl_reg_subsite: str(srv?.BodySubSite) || "",
          nonstd_cde: "",
          nonstd_disp: "",
          pres_med: {
            type: str(srv?.MedicationServiceType) || "",
            code: str(srv?.MedicationServiceCode) || "",
            url: "",
          },
          Sntfc_code_abs_rsn:
            str(srv?.MedicationScientificCodeAbsenceReason) || "",
          Sntfc_code_abs_rsn_oth:
            str(srv?.MedicationScientificCodeAbsenceReasonOthers) || "",
          pselrsn: str(srv?.MedicationSelectionReason) || "",
          pharsubs: str(srv?.MedicationPharmacySubstitute) || "",
          pharsubsrsn: str(srv?.MedicationPharmacySubstituteOther) || "",
          diag: diagnoses.map((d) => str(d.ICD10_Code)).filter(Boolean),
          supinfo3: [],
          supinfo1: [],
        };
      });

      // === Patient Name Split ===
      const fullName = str(mainRow.Patient_Name);
      const parts = fullName.split(/\s+/).filter(Boolean);

      let patient_finame = "";
      let patient_faname = "";

      if (parts.length === 1) {
        patient_finame = parts[0];
        patient_faname = parts[0];
      } else if (parts.length >= 2) {
        patient_finame = parts.slice(0, -1).join(" ");
        patient_faname = parts[parts.length - 1];
      }

      let prescp = null;
      if (optical) {
        console.log({ optical: "Yes" });
        const normalizedOptical = Object.fromEntries(
          Object.entries(optical).map(([k, v]) => [k.toLowerCase(), v])
        );

        const productType = str(
          normalizedOptical["product_type"]
        ).toLowerCase();

        const buildEyePrescription = (side, type) => {
          const base = `${side}_eye_${type}_`;

          const getField = (key) => {
            const fieldName = `${base}${key.toLowerCase()}`;
            const val = normalizedOptical[fieldName];
            return val != null ? String(val).trim() : "";
          };

          console.log({ getField });

          const prismValues = [
            { amount: parseFloat(getField("primin")) || "", base: "in" },
            { amount: parseFloat(getField("prismout")) || "", base: "out" },
            { amount: parseFloat(getField("prismdown")) || "", base: "down" },
            { amount: parseFloat(getField("prismup")) || "", base: "up" },
          ].filter((p) => p.amount !== "" && p.amount !== 0);

          const prescription = {
            eye: side,
            sphere: getField("sph"),
            cylinder: getField("cyl"),
            axis: getField("axis"),
            add: normalizedOptical[`${side}_add`]
              ? String(normalizedOptical[`${side}_add`]).trim()
              : "",
            brand: "",
            color: "",
            power: getField("power"),
            duration: normalizedOptical[`${side}duration`]
              ? String(normalizedOptical[`${side}duration`]).trim()
              : "",
            duration_typ: normalizedOptical[`${side}durationunit`]
              ? String(normalizedOptical[`${side}durationunit`]).trim()
              : "",
            bckcurve: getField("backcurve"),
            dmeter: getField("diameter"),
            prism: productType === "lens" ? prismValues : [],
          };

          // Set fields to empty based on productType
          if (productType === "lens") {
            prescription.power = "";
            prescription.bckcurve = "";
            prescription.dmeter = "";
            prescription.duration = "";
            prescription.duration_typ = "";
          } else if (productType === "contact") {
            prescription.sphere = "";
            prescription.prism = [];
          }

          // 👇 Only add note if any of the "optical" fields are filled
          const hasNoteField = [
            prescription.sphere,
            prescription.power,
            prescription.cylinder,
            prescription.axis,
            ...prismValues.map((p) => p.amount),
            prescription.bckcurve,
            prescription.dmeter,
          ].some((val) => val !== "" && val !== undefined && val !== "");

          if (hasNoteField) {
            prescription.note = [{ text: type }];
          }

          // Remove if all values are ""/empty
          const hasRealData = Object.entries(prescription).some(
            ([key, val]) => {
              if (key === "eye") return false;
              if (Array.isArray(val)) return val.length > 0;
              return val !== "" && val !== undefined && val !== "";
            }
          );

          return hasRealData ? prescription : "";
        };

        prescp = {
          lens_typ: productType || "",
          prescp_dte: formatDate(normalizedOptical["prescriptiondate"]) || "",
          isframe:
            productType === "lens"
              ? str(normalizedOptical["is_frame"]).toUpperCase() === "Y"
                ? true
                : false
              : false,
          regular_lenses:
            productType === "lens"
              ? str(normalizedOptical["regular_lenses_type"])
              : "" || "",
          lens_specifications:
            productType === "lens" && normalizedOptical["lense_specification"]
              ? [str(normalizedOptical["lense_specification"])]
              : "",
          regular_contact:
            productType === "contact"
              ? str(normalizedOptical["contact_lense_type"])
              : "",
        };

        const allPrescriptions = [
          buildEyePrescription("right", "distance"),
          buildEyePrescription("right", "near"),
          buildEyePrescription("left", "distance"),
          buildEyePrescription("left", "near"),
        ];

        // Dynamically add with keys starting from "1"
        let presIndex = 1;
        allPrescriptions.forEach((entry) => {
          if (entry) {
            prescp[presIndex.toString()] = entry;
            presIndex++;
          }
        });
      }

      if (isVision && !prescp) {
        console.log({ prescp: "Test" });
        prescp = "";
      }

      // === Final Claim Object ===
      const singleClaimBody = {
        claim_type: claimTypeCode,
        claimsub_types_name: num(mainRow.Claim_Sub_Type) || 0,
        process_prior: "normal",
        preauth_ref:
          Array.from(
            new Set(services.map((s) => str(s.PREAUTH)).filter((ref) => ref))
          ).join(",") || "",
        patient_eligbid: "",
        patient_preauthid: "",
        prescp_no: "",
        patient_eligbdte: "",
        patient_offeligbid: "",
        patient_offeligbdte: "",
        preauthid: "",
        reln_prior: "",
        referral_req: "",
        prescript_submt: isPrescription,
        patient_natid: str(mainRow.Patient_ID) || "",
        patient_finame: patient_finame || "",
        patient_faname: patient_faname || "",
        patient_dob: formatDate(mainRow.Patient_DateofBirth) || "",
        patient_mrn: str(mainRow.Patient_File_No) || "",
        patient_benf_benf_type: "self",
        idenf_type: num(mainRow.Patient_IdentifierType) || 0,
        patient_gender: str(mainRow.Patient_Gender)?.toLowerCase() || "",
        patient_marital: str(mainRow.Patient_MaritalStatus) || "",
        patient_profession:
          str(mainRow.Patient_Occupation)?.toLowerCase() || "",
        patient_memid: str(mainRow.Membership_No) || "",
        patient_tel: str(mainRow.MobileNumber) || "",
        accident_date: formatDate(mainRow.AccidentDate) || "",
        accident_type: str(mainRow?.AccidentType) || "",
        accident_address: str(mainRow?.["Accident Address"]) || "",
        patient_benf_gender: str(mainRow.Patient_Gender)?.toLowerCase() || "",
        patient_religion: str(mainRow.Patient_Religion) || "",
        patient_nationality: str(mainRow.Nationality) || "",
        patient_plynum: str(mainRow.Policy_No) || "",
        patient_ntwrkno: "",
        patient_benf_finame: str(mainRow.BeneficiaryFirstName) || "",
        patient_benf_faname: str(mainRow.BeneficiaryLastName) || "",
        patient_clsnme: str(mainRow.Patient_Class) || "",
        claimbatch_no: "",
        patient_benf_marital: "",
        patient_benf_religion: "",
        patient_benf_profession: "",
        patient_benf_mrn: str(mainRow.BeneficiaryMRN) || "",
        patient_benf_dob: formatDate(mainRow.BeneficiaryBirthDate) || "",
        clncldata: str(mainRow?.Clinical_Data) || "",
        patient_benf_id: "",
        patient_polcyholdr: str(mainRow.Policy_Name) || "",
        patient_polcyholdrnum: "",
        othrconditions: str(mainRow?.Other_Condition) || "",
        prescrptn_refno: "",
        claim_id: "",
        sgnfcntsign: str(mainRow?.Significant_Sign) || "",
        patient_relation: str(mainRow.Relationship) || "self",
        patient_nwbrnrel:
          str(mainRow.Is_Newborn)?.toLowerCase() == "y" ? "Child" : "",
        new_brn: str(mainRow.Is_Newborn)?.toLowerCase() == "y" ? true : "",
        enct_cls:
          isEncounterClass
            ? str(mainRow.EncounterClass)
            : "",
        claim_enctres: !isVision && !isPharmacy && !isPrescription ? "on" : "",
        sup_info,
        prescp,
        enct_stdate:
          isAdmissionDate
            ? formatDate(mainRow.AdmissionDate)
            : "",
        enct_eddate:
          isDischargeDate
            ? formatDate(mainRow.DischargeDate)
            : "",
        enct_serv_typ:
          isCareType
            ? str(mainRow.CareType)
            : "",
        enct_prior: isActPriorty ? "EL" : "",
        enct_emrgdeptdisp:
          isEmerDepartDis
            ? str(mainRow?.EmergencyDepartmentDisposition)
            : "",
        enct_emrgarvlcde:
          isEmerArrivalCode
            ? str(mainRow?.EmergencyArrivalCode)
            : "",
        enct_emergservst:
          isEmerServStartDate
            ? formatDate(mainRow.EmergencyServiceStartDate)
            : "",
        enct_trgctg:
          isTriage
            ? str(mainRow?.TriageCategoryType)
            : "",
        enct_trgdte:
          isTriage
            ? formatDate(mainRow.TriageDate)
            : "",
        enct_hosp_intdlghsty:
          isIntendLength
            ? str(mainRow?.IntendedLengthOfStay)
            : "",
        enct_hosp_discgspeclty:
          isDischargeSpeciality
            ? str(mainRow?.DischargeSpeciality)
            : "",
        enct_hosp_admnspeclty: "",
        enct_adm_srce:
          isEncounterAdmitSource
            ? str(mainRow.EncounterAdmitSource)
            : "",
        enct_preadmn: "",
        enct_disdisp:
          isDischargeDisposition
            ? str(mainRow?.DischargeDisposition)
            : "",
        enct_csedth:
          isCauseOfDeath
            ? str(mainRow?.CauseOfDeath)
            : "",
        enct_sevnttyp:
          isServiceEventType
            ? str(mainRow.ServiceEventType)
            : "",
        enct_status:
          isEncounterStatus
            ? str(mainRow.EncounterStatus)?.toLowerCase()
            : "",
        diag,
        prd_ser,
        sup_info_attch: {},
        sup_info_labt: {},
        sup_info_suply,
        pract_id,
      };

      body.claim_data[claimKey] = cleanObjectExcept(singleClaimBody, [
        "sup_info",
        "pract_id",
        "prd_ser.prd_url_txt",
      ]);
    });

    console.log({ body });
    // return;

    const response = await dispatch(
      CreateMultipleClaimFromExcel(body)
    ).unwrap();
    if (response?.status_code === "200") {
      toast.success(response?.message_en);
      dispatch(handleResetExcel()); // Clears excelData from Redux
      dispatch(setIsExcelValid(false)); // Critical: disable upload button
      dispatch(setValidationExcelErrors([]));
      dispatch(setValidationErrors([]));
      allData = [];
      reset();
      setFile(null);
      navigate("/claims/claims-list");
    } else {
      toast.error(response?.message_en);
    }
  };
  console.log({
    isExcelValid,
    payer: watch("payer"),
    date: watch("claim_date"),
    file: watch("excelFile"),
    mainData,
  });
  return (
    <Form noValidate className="p-0" onSubmit={handleSubmit(onSubmit)}>
      <FalconComponentCard className="shadow-md">
        <FalconComponentCard.Header
          className="d-flex fixed-header justify-content-between align-items-center"
          sx={{
            position: "sticky !important",
            top: 68,
            zIndex: 1020,
            backgroundColor: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <BackButton path={paths.claimsList} title="Claim Import" />
          <Col xs="auto" className="d-flex gap-2">
            <Button
              type="submit"
              size="sm"
              variant="success"
              disabled={
                !watch("payer") ||
                !watch("claim_date") ||
                !isExcelValid ||
                !file
              }
            >
              Upload
            </Button>
          </Col>
        </FalconComponentCard.Header>
        <FalconComponentCard.Body
          style={{
            marginTop: "40px",
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)",
          }}
        >
          <Row>
            <Col xs={12}>
              <ClaimUpload
                control={control}
                errors={errors}
                setValue={setValue}
                setFile={setFile}
                file={file}
                watch={watch}
              />
            </Col>
          </Row>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Form>
  );
};
export default ClaimImport;
